export default __webpack_public_path__ + "static/media/background-chase-dark.39ae9b97.png";